import React from 'react'
import {
  IProps as IResourcesBanner,
  ResourcesBanner,
} from 'marketing-site/src/library/components/ResourcesBanner'

import { IResourcesBanner as IContentfulResourcesBanner } from 'marketing-site/@types/generated/contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'

export const ContentfulResourcesBanner = (header: IContentfulResourcesBanner) => (
  <EntryMarker entry={header}>
    {() => <ResourcesBanner {...transformResourcesBanner(header)} />}
  </EntryMarker>
)

export function transformResourcesBanner({ fields }: IContentfulResourcesBanner): IResourcesBanner {
  return {
    ...fields,
    leftImage: fields.leftImage.fields.file.url,
    heading: fields.heading,
    subHeading: fields.subHeading,
    rightImage: fields.rightImage.fields.file.url,
  }
}
